import { PageLink, PageLinkCondition } from 'types/pages'

const DEFAULT_SUPPLIER_PAGE_CONDITION: PageLinkCondition = {
  'supplier-selection': { message: 'Please select a supplier for which the report needs to be generated!' },
}

export const SUPPLIER_REPORT_PAGES: PageLink[] = [
  {
    text: 'Depot Delivery',
    accessLevel: 'Depot Delivery',
    routeTo: '/supplier/depot-delivery',
    icon: 'depot-delivery',
    reportName: 'depotDelivery',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Distribution Centre Outbound',
    accessLevel: 'Distribution Centre Outbound',
    routeTo: '/supplier/distribution-centre-outbound',
    icon: 'modify-access',
    reportName: 'dcoutbound',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Online Sales',
    accessLevel: 'Online Sales',
    routeTo: '/supplier/sales-home/online',
    icon: 'online-sales',
    reportName: 'onlineSales',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Promotion Forecast',
    accessLevel: 'Promotion Forecast',
    routeTo: '/supplier/promotion-forecast',
    icon: 'promotion-forecast',
    reportName: 'promofrcst',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Purchase Order',
    accessLevel: 'Purchase Order',
    routeTo: '/supplier/purchase-order',
    icon: 'purchase-order',
    reportName: 'po',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Sales',
    accessLevel: 'Sales',
    routeTo: '/supplier/sales-home/sales',
    icon: 'sales',
    reportName: 'sales',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Store Sales',
    accessLevel: 'Store Sales',
    routeTo: '/supplier/sales-home/store',
    icon: 'store-sales',
    reportName: 'storeSales',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Store Stock',
    accessLevel: 'Store Stock',
    routeTo: '/supplier/store-stock',
    icon: 'store-stock',
    reportName: 'storeStock',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Supplier Service',
    accessLevel: 'Supplier Service',
    routeTo: '/supplier/supplier-service',
    icon: 'inbound-service-level',
    reportName: 'supplierService',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Wholesale Sales',
    accessLevel: 'Wholesale Sales',
    routeTo: '/supplier/sales-home/wholesale',
    icon: 'wholesale-sales',
    reportName: 'wholesaleSales',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Depot Stock',
    accessLevel: 'Depot Stock',
    routeTo: '/supplier/depot-stock',
    icon: 'depot-stock',
    reportName: 'depotStock',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Product Reference',
    accessLevel: 'Product Reference',
    routeTo: '/supplier/product-reference',
    icon: 'product-reference',
    reportName: 'productReference',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Sales Forecast',
    accessLevel: 'Sales Forecast',
    routeTo: '/supplier/sales-forecast',
    icon: 'sales-forecast',
    reportName: 'salesForecast',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Supplier Order Forecast',
    accessLevel: 'Supplier Order Forecast',
    routeTo: '/supplier/order-forecast',
    icon: 'order-forecast',
    reportName: 'supplierOrderForecast',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Wastage & Markdown',
    accessLevel: 'Wastage And Markdown',
    routeTo: '/supplier/wastage-and-markdown',
    icon: 'wastage-and-markdown',
    reportName: 'wastageAndMarkdown',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Availability',
    accessLevel: 'Availability',
    routeTo: '/supplier/availability',
    icon: 'store-stock',
    reportName: 'availability',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Morrisons Documents',
    accessLevel: 'Morrisons Documents (Supplier)',
    routeTo: '/supplier/morrisons-documents',
    icon: 'morrisons-documents',
  },
  {
    text: 'Ranged Products',
    accessLevel: 'Ranged Products',
    routeTo: '/supplier/ranged-products',
    icon: 'ranged-products',
    reportName: 'rangedProducts',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Depot Rejections',
    accessLevel: 'Depot Rejections',
    routeTo: '/supplier/depot-rejections',
    icon: 'online-sales',
    reportName: 'depotRejections',
    condition: DEFAULT_SUPPLIER_PAGE_CONDITION,
  },
  {
    text: 'Download CSV Reports',
    accessLevel: 'Supplier Reports',
    routeTo: '/supplier/reports',
    condition: {
      'supplier-selection': {
        message: 'Please select a supplier for which the generated reports need to be displayed!',
      },
    },
  },
]

export const MANAGE_ACCESS_PAGES: PageLink[] = [
  {
    text: 'Grant Access',
    accessLevel: 'Grant Access',
    routeTo: '/admin/grant-user-access',
    icon: 'grant-access',
  },
  {
    text: 'Modify Access',
    accessLevel: 'Modify Access',
    routeTo: '/admin/modify-user-access',
    icon: 'modify-access',
  },
  {
    text: 'Create User Roles',
    accessLevel: 'Create User Roles',
    routeTo: '/admin/create-user-roles',
    icon: 'people',
  },
  {
    text: 'Amend User Roles',
    accessLevel: 'Amend User Roles',
    routeTo: '/admin/amend-user-roles',
    icon: 'people',
  },
  {
    text: 'Add Company/Group',
    accessLevel: 'Add Company/Group',
    routeTo: '/admin/create-company-profile',
    icon: 'create-company-profile',
  },
  {
    text: 'Manage Company/Group Profile',
    accessLevel: 'Manage Company/Group Profile',
    routeTo: '/admin/manage-company-profile',
    icon: 'manage-company-profile',
  },
  {
    text: 'View Associated Group(s)',
    accessLevel: 'View Associated Groups',
    routeTo: '/admin/view-associated-groups',
    icon: 'people',
  },
]

export const ADMIN_COMMUNICATION_PAGES: PageLink[] = [
  {
    text: 'Add New Message',
    accessLevel: 'Add New Message',
    routeTo: '/admin/add-message',
    icon: 'add-new-message',
  },
  {
    text: 'Amend/Delete Message',
    accessLevel: 'Amend/Delete Message',
    routeTo: '/admin/amend-message',
    icon: 'amend-delete-message',
  },
  {
    text: 'Add/Remove Morrisons Documents',
    accessLevel: 'Morrisons Documents (Admin)',
    routeTo: '/admin/morrisons-documents',
    icon: 'morrisons-documents',
  },
]

export const SUPPLIER_ADMIN_PAGES: PageLink[] = [
  {
    text: 'Remove User',
    accessLevel: 'Supplier Admin',
    routeTo: '/supplier-admin/remove-user',
    icon: 'modify-access',
  },
  {
    text: 'Add/Remove Consolidator/Haulier',
    accessLevel: 'Supplier Admin',
    routeTo: '/supplier-admin/add-consolidator-haulier',
    icon: 'create-company-profile',
  },
]

export const CONSOLIDATOR_HAULIER_ADMIN_PAGES: PageLink[] = [
  {
    text: 'Remove User',
    accessLevel: 'Consolidator/Haulier Admin',
    routeTo: '/consolidator-haulier-admin/remove-user',
    icon: 'modify-access',
  },
]

export const MISC_PAGES: PageLink[] = [
  {
    text: 'Software License Agreement Relating To Morrisons Supplier Data Hub',
    routeTo: '/tnc',
  },
]

export const ALL_PAGES: PageLink[] = [
  ...SUPPLIER_REPORT_PAGES,
  ...MANAGE_ACCESS_PAGES,
  ...ADMIN_COMMUNICATION_PAGES,
  ...SUPPLIER_ADMIN_PAGES,
  ...CONSOLIDATOR_HAULIER_ADMIN_PAGES,
  ...MISC_PAGES,
]
